import { cn } from "./classNames-BzrkDnOD.js";
import { Minus } from "./icons-DcNsvqse.js";
import { use } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { OTPInput, OTPInputContext, REGEXP_ONLY_CHARS, REGEXP_ONLY_DIGITS, REGEXP_ONLY_DIGITS as REGEXP_ONLY_DIGITS$1, REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";
//#region src/blocks/OtpInput/OtpInputGroup.tsx
const OtpInputGroup = ({ ref, className, ...props }) => /* @__PURE__ */ jsx("div", {
	ref,
	className: cn("tw:flex tw:items-center tw:gap-2", className),
	...props
});
//#endregion
//#region src/blocks/OtpInput/OtpInputSeparator.tsx
const OtpInputSeparator = ({ ref, children, className, ...props }) => /* @__PURE__ */ jsx("div", {
	ref,
	role: "separator",
	"aria-orientation": "vertical",
	className: cn("tw:flex tw:items-center tw:text-muted-foreground", className),
	...props,
	children: children ?? /* @__PURE__ */ jsx(Minus, { className: "tw:size-4" })
});
//#endregion
//#region src/blocks/OtpInput/OtpInputSlot.tsx
const slotClassName = [
	"tw:relative",
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:font-medium",
	"tw:tabular-nums",
	"tw:outline-hidden",
	"tw:transition",
	"tw:border",
	"tw:border-solid",
	"tw:border-input",
	"tw:bg-muted",
	"tw:text-foreground",
	"tw:rounded-[var(--radius-lg,0.25rem)]",
	"tw:data-[active=true]:z-10",
	"tw:data-[active=true]:border-primary",
	"tw:data-[active=true]:ring-4",
	"tw:data-[active=true]:ring-ring/50",
	"tw:group-data-[size=sm]/otp:h-8 tw:group-data-[size=sm]/otp:w-8 tw:group-data-[size=sm]/otp:text-sm",
	"tw:group-data-[size=md]/otp:h-9 tw:group-data-[size=md]/otp:w-9 tw:group-data-[size=md]/otp:text-base",
	"tw:group-data-[size=lg]/otp:h-10 tw:group-data-[size=lg]/otp:w-10 tw:group-data-[size=lg]/otp:text-lg",
	"tw:group-has-[input[aria-invalid=true]]/otp:!border-destructive",
	"tw:group-has-[input[aria-invalid=true]]/otp:data-[active=true]:!border-destructive",
	"tw:group-has-[input[aria-invalid=true]]/otp:data-[active=true]:ring-destructive/20"
];
const OtpInputSlot = ({ ref, index, className, ...props }) => {
	const { slots } = use(OTPInputContext);
	if (!slots) throw new Error("<OtpInput.Slot> must be rendered inside <OtpInput>.");
	const slot = slots[index];
	const char = slot?.char ?? null;
	const isActive = slot?.isActive ?? false;
	const hasFakeCaret = slot?.hasFakeCaret ?? false;
	return /* @__PURE__ */ jsxs("div", {
		ref,
		"data-active": isActive || void 0,
		"data-slot-index": index,
		className: cn(slotClassName, className),
		...props,
		children: [char, hasFakeCaret && /* @__PURE__ */ jsx("div", {
			"aria-hidden": "true",
			className: "tw:pointer-events-none tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center",
			children: /* @__PURE__ */ jsx("div", { className: "tw:h-1/2 tw:w-px tw:animate-caret-blink tw:bg-foreground" })
		})]
	});
};
//#endregion
//#region src/blocks/OtpInput/OtpInput.tsx
const Root = ({ ref, sizing = "md", pattern = REGEXP_ONLY_DIGITS, containerClassName, className, children, "aria-invalid": ariaInvalid, ...rest }) => /* @__PURE__ */ jsx("div", {
	className: "tw:group/otp tw:w-fit",
	"data-size": sizing,
	children: /* @__PURE__ */ jsx(OTPInput, {
		...rest,
		ref,
		pattern,
		"aria-invalid": ariaInvalid,
		containerClassName: cn("tw:flex tw:items-center tw:gap-2 tw:has-[:disabled]:opacity-50", containerClassName),
		className: cn("tw:disabled:cursor-not-allowed", className),
		children
	})
});
const OtpInput = Object.assign(Root, {
	Group: OtpInputGroup,
	Slot: OtpInputSlot,
	Separator: OtpInputSeparator
});
//#endregion
export { OtpInput, REGEXP_ONLY_CHARS, REGEXP_ONLY_DIGITS$1 as REGEXP_ONLY_DIGITS, REGEXP_ONLY_DIGITS_AND_CHARS };

//# sourceMappingURL=OtpInput-BZAyjl8M.js.map